import { fetchProductsByCategory } from "src/services/ProductApi";
import { ProductCategory } from "src/enum/ProductEnum";
import { store } from "src/store/store";
import {
  setBestSellerCategory,
  setNewArrivalCategory,
  setTrendingCategory,
} from "src/store/slices/productCategory-slice";
import { setSelectedProductCategory } from "src/store/slices/selectedProductCategory-slice";
import { isVideoPath } from "src/utils/imageUrl";
export const fetchAndSetProducts = async (
  setProductsState,
  activeTab,
  setLoading
) => {
  if (!activeTab) {
    setProductsState([]);
    return;
  }

  setLoading(true);
  const fetchedProducts = await fetchProductsByCategory(activeTab, 8);
  setProductsState(fetchedProducts);
  setLoading(false);
};

export const setProductStatusAvailable = async (
  setProductsState,
  setSelectedProductCategory,
  setLoading
) => {
  if (setLoading) setLoading(true);

  for (let category = 1; category <= 3; category++) {
    try {
      const products = await fetchProductsByCategory(category, 8);

      if (products.length > 0) {
        if (setSelectedProductCategory) setSelectedProductCategory(category);
        await fetchAndSetProducts(setProductsState, category, setLoading);
        return;
      }
    } catch (error) {
      console.error("Error setting product status:", error);
    }
  }

  if (setLoading) setLoading(false);
};

// Looks up a product by slug in an already-fetched product list.
// Returns the product if found, null if the list is populated but the slug
// isn't in it (a real "not found"), or undefined if the list isn't ready yet
// (e.g. still `{}` from the redux initial state) so the caller should wait.
export const findAndSetProduct = (AllProducts, slug) => {
  if (!Array.isArray(AllProducts) || AllProducts.length === 0) {
    return undefined;
  }
  return AllProducts.find((item) => item.slug === slug) || null;
};

export const formatProductsForSlider = (products) => {
  return products.map(product => {
    // Cards can't play videos, so only consider photo entries
    const photos = (product.images || []).filter((img) => !isVideoPath(img?.imagePath));
    return {
      id: product.slug,
      slug: product.slug,
      name: product.name,
      price: product.price,
      oldPrice: product.markedPrice,
      image: photos.length > 0 ? photos[0].imagePath : "",
      hoverImage: photos.length > 1 ? photos[1].imagePath :
        (photos.length > 0 ? photos[0].imagePath : ""),
      type: product.category,
      tags: product.discount > 0 ? [{ type: "discount", value: `${product.discount}% OFF` }] : [],
      variants: product.variants || []
    };
  });
};

export const setProductStatusRedux = async () => {
  for (const [key, value] of Object.entries(ProductCategory)) {
    try {
      const products = await fetchProductsByCategory(value, 8);
      const hasProducts = products.length > 0;

      switch (key) {
        case "Trending":
          store.dispatch(setTrendingCategory(hasProducts));
          break;
        case "NewArrival":
          store.dispatch(setNewArrivalCategory(hasProducts));
          break;
        case "BestSeller":
          store.dispatch(setBestSellerCategory(hasProducts));
          break;
        default:
          console.warn(`Unknown product category: ${key}`);
          break;
      }
    } catch (error) {
      console.error(`Error setting product status for ${key}:`, error);
    }
  }
};

export const handleProductCategoryNavbarClick = (productCategory, navigate) => {
  switch (productCategory) {
    case "Trending":
      store.dispatch(setSelectedProductCategory(ProductCategory.Trending));
      navigate(`/productcategory/Trending`);
      break;
    case "New Arrivals":
      store.dispatch(setSelectedProductCategory(ProductCategory.NewArrival));
      navigate(`/productcategory/NewArrivals`);
      break;
    case "Best Sellers":
      store.dispatch(setSelectedProductCategory(ProductCategory.BestSeller));
      navigate(`/productcategory/BestSellers`);
      break;
    default:
      console.warn(`Unknown product category: ${productCategory}`);
      break;
  }
};

export const handleCategoryNavbarClick = (category, navigate) => {
  if (category === "Shop All") {
    navigate("/category/all");
    return;
  }
  navigate(`/category/${category}`);
};
